import { ReactSortable } from 'react-sortablejs';
import ManageQuiz from './ManageQuiz';

function QuizListing({ courseID, chapterID, quizzes = [], setList, handleSort }) {
  return (
    <ReactSortable
      list={quizzes}
      setList={setList}
      handle=".quizGrabHandleID"
      onSort={() => handleSort(chapterID)}
    >
      {quizzes?.map((quiz) => {
        return (
          <ManageQuiz courseID={courseID} key={quiz.id} selectedQuiz={quiz} chapterID={chapterID} />
        );
      })}
    </ReactSortable>
  );
}

export default QuizListing;
